import { useEffect, useState } from "react";
import { AuthedApi } from "./Api";
import { Action, VoidAction } from "../util/func";
import useAsyncUpdate from "../util/useAsyncUpdate";

export default function useAuthedApi(showError: Action<string>): [AuthedApi | null | undefined, VoidAction] {
  const [authedApi, setAuthedApi] = useState<AuthedApi | null>();

  useEffect(() => {
    if (!authedApi) {
      update();
    }
  }, [authedApi]);

  const update = () => AuthedApi.Get(() => setAuthedApi(null), showError).then(setAuthedApi);

  return [authedApi, update];
}

